import { render, staticRenderFns } from "./EsyButton.vue?vue&type=template&id=8df06850&scoped=true"
import script from "./EsyButton.vue?vue&type=script&lang=ts"
export * from "./EsyButton.vue?vue&type=script&lang=ts"
import style0 from "./EsyButton.vue?vue&type=style&index=0&id=8df06850&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df06850",
  null
  
)

export default component.exports